import React from "react";
import Icon from "./Icon";

export const AddonNotCheckedIcon = () => (
  <Icon>
    <circle cx="12" cy="12" r="12" fill="#FAE6E8"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7213 8.33625C17.0133 8.04423 17.0133 7.57077 16.7213 7.27875C16.4292 6.98673 15.9558 6.98673 15.6638 7.27875L12 10.9425L8.33625 7.27875C8.04423 6.98673 7.57077 6.98673 7.27875 7.27875C6.98673 7.57077 6.98673 8.04423 7.27875 8.33625L10.9425 12L7.27875 15.6638C6.98673 15.9558 6.98673 16.4292 7.27875 16.7213C7.57077 17.0133 8.04423 17.0133 8.33625 16.7213L12 13.0575L15.6638 16.7213C15.9558 17.0133 16.4292 17.0133 16.7213 16.7213C17.0133 16.4292 17.0133 15.9558 16.7213 15.6638L13.0575 12L16.7213 8.33625Z" fill="#D0021B"/>
  </Icon>
);
